import React from 'react'
// import { Link } from 'react-router-dom';
import resources from '../../../services'
import DataTable from '../../../composents/DataTable'
import MainPage from '../../../composents/MainPage'
import { useAlert } from '../../../ui/Alert'
import moment from 'moment'
import config from '../../../constants'

const title = 'Water cards'
const headers = {
  icon: 'feather icon-credit-card',
  title: title,
  description: 'track and manage all water cards information',
}

export default function WaterCardPage() {
  const { push } = useAlert()

  async function updateCours(el, value, callback) {
    if (el?.user?.id) {
      el = {
        ...el,
        user: el.user.id,
      }
    }
    if (el?.subscription?.id) {
      el = {
        ...el,
        subscription: el.subscription.id,
      }
    }
    if (el?.cardPermission?.id) {
      el = {
        ...el,
        cardPermission: el.cardPermission.id,
      }
    }
    el = {
      ...el,
      status: value,
      validityFrom: moment(el.validityFrom).format('DD-MM-YYYY'),
      validityTo: moment(el.validityTo).format('DD-MM-YYYY'),
    }
    let res = await resources.card
      .update(el.id, el)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      callback()
      push({
        success: true,
      })
    } else if (res.status === 403) {
      push({
        error: true,
        message: config.app.error,
      })
    }
  }

  return (
    <MainPage headers={headers} show_search>
      <DataTable
        column={[
          {
            label: 'Consumer',
            field: 'user',
            render: ['surname'],
          },
          {
            label: 'Card id',
            field: 'cardId',
          },
          {
            label: 'Balance',
            field: 'balance',
          },
          {
            label: 'Card number',
            field: 'cardNumber',
          },
          {
            label: 'Permission',
            field: 'cardPermission',
            render: ['title'],
          },
          {
            label: 'Card Type',
            field: 'cardType',
          },
          {
            label: 'card validity',
            field: 'validityTo',
            isDate: true,
          },
          {
            label: 'Status',
            field: 'status',
            renderStyle: (data) => {
              return (
                <p>
                  {data.status === 1 && (
                    <label className="form-label label label-success">active</label>
                  )}
                  {data.status === 2 && (
                    <label className="form-label label label-danger">inactive</label>
                  )}
                </p>
              )
            },
          },
        ]}
        resource={resources.card}
        title={title}
        link="/water_cards/digi_cards"
        action={(data, callback) => {
          return (
            <>
              {data.status === 1 ? (
                <li onClick={() => updateCours(data, 2, callback)}>
                  <span
                    className="dropdown-item"
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    <i className="feather icon-lock"></i> deactivate
                  </span>
                </li>
              ) : (
                <li onClick={() => updateCours(data, 1, callback)}>
                  <span
                    className="dropdown-item"
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    <i className="feather icon-unlock"></i> activate
                  </span>
                </li>
              )}

              {/*{data.user && data.status === 1 && (*/}
              {/*	<li>*/}
              {/*		<a*/}
              {/*			className="dropdown-item"*/}
              {/*			href={*/}
              {/*				'/hydrowallet/digi_cards/top_up/' +*/}
              {/*				data.id*/}
              {/*			}*/}
              {/*		>*/}
              {/*			<i className="feather icon-credit-card"></i>{' '}*/}
              {/*			Top up*/}
              {/*		</a>*/}
              {/*	</li>*/}
              {/*)}*/}
            </>
          )
        }}
      />
    </MainPage>
  )
}
